import { render, staticRenderFns } from "./PlaceDetails.vue?vue&type=template&id=5fcad8fe&scoped=true"
import script from "./PlaceDetails.vue?vue&type=script&lang=js"
export * from "./PlaceDetails.vue?vue&type=script&lang=js"
import style0 from "./PlaceDetails.vue?vue&type=style&index=0&id=5fcad8fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcad8fe",
  null
  
)

export default component.exports